import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Gallery() {
  const [branches, setBranches] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => {
    api.get("/branches").then((r) => {
      setBranches(r.data);
      setActive(r.data[0]?.id || null);
    });
  }, []);
  const cur = branches.find((b) => b.id === active);
  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="label-eyebrow mb-4">Visual Archive</div>
      <h1 className="text-5xl lg:text-6xl font-heading text-white mb-10">Gallery</h1>
      <div className="flex gap-3 mb-8 flex-wrap">
        {branches.map((b) => (
          <button key={b.id} onClick={() => setActive(b.id)} data-testid={`gallery-tab-${b.slug}`} className={`px-4 py-2 border text-xs uppercase tracking-widest ${active === b.id ? "border-hgold text-hgold" : "border-white/10 text-white/60 hover:border-hgold/50"}`}>{b.name}</button>
        ))}
      </div>
      {cur && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {cur.gallery?.map((g, i) => (
            <img key={i} src={g} alt="" className="aspect-square w-full object-cover hover:scale-105 transition-transform duration-500" />
          ))}
        </div>
      )}
    </div>
  );
}
